import { render, staticRenderFns } from "./MakCamera.vue?vue&type=template&id=0efae918&scoped=true&"
import script from "./MakCamera.vue?vue&type=script&lang=js&"
export * from "./MakCamera.vue?vue&type=script&lang=js&"
import style0 from "./MakCamera.vue?vue&type=style&index=0&id=0efae918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efae918",
  null
  
)

export default component.exports